var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-panel"},[_c('div',{staticClass:"loading"},[_c('pulse-loader',{attrs:{"color":"#20a8d8"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }